import { FC, Fragment } from 'react';
import { Card, Flex, List } from 'antd';
import { PageName, useApp } from '@/App';
import CountUp from 'react-countup';
import { useThingsToDo } from '@/libs/fleet-api/services/things-todo';

const CHThingsToDo: FC = () => {
	const { navigate } = useApp();
	const { data: todoData, isLoading } = useThingsToDo();
	const counts = todoData?.data;

	const data = [
		{
			title: 'Survey Approval',
			count: counts?.surveyApproval ?? 0,
			link: 'CHSurveyApprovalListPage',
		},
		{
			title: 'Laporan Kunjungan Approval',
			count: counts?.visitReport ?? 0,
			link: 'CHVisitReportListPage',
		},
		{
			title: 'Pipeline Hot Prospect',
			count: counts?.pipelineHotProspect ?? 0,
			link: 'CHPipelineListPage',
		},
		{
			title: 'Monitoring Pipeline Golive',
			count: counts?.pipelineGoLive ?? 0,
			link: 'GoliveListPage',
		},
		{
			title: 'Nota Analisa Pembiayaan',
			count: counts?.nap ?? 0,
			link: 'NAPListPage',
		},
	];

	return (
		<Fragment>
			<List
				loading={isLoading}
				grid={{ gutter: 20, column: 2 }}
				dataSource={data}
				renderItem={(item) => {
					return (
						<List.Item style={{ marginBottom: 20 }}>
							<Card
								hoverable
								size="small"
								style={{ borderRadius: 0 }}
								onClick={() => {
									navigate(item.link as PageName);
								}}
							>
								<Flex
									justify="space-between"
									align="center"
								>
									{item.title}
									<div
										className={`badge-todo ${item.count > 0 ? 'badge-active' : ''}`}
									>
										<CountUp end={item.count} />
									</div>
								</Flex>
							</Card>
						</List.Item>
					);
				}}
			/>
		</Fragment>
	);
};

export default CHThingsToDo;
